import classNames from 'classnames'
import type { FC } from 'react'

import styles from './seriesModeRow.module.scss'
import { SERIES_TEXT_V2 } from './seriesText'
import type { SeriesTab, SeriesTabName } from './useSeriesTab'

type Props = {
  tab: Pick<SeriesTab, 'visible' | 'switchDisabled' | 'isSeries' | 'note' | 'setTab'>
  // A save in flight keeps the tab it started on.
  isBusy?: boolean
}

const TABS: { name: SeriesTabName; label: string }[] = [
  { name: 'single', label: SERIES_TEXT_V2.modeSingle },
  { name: 'series', label: SERIES_TEXT_V2.modeSeries },
]

export const SeriesModeRow: FC<Props> = ({ tab, isBusy = false }) => {
  if (!tab.visible) return null
  const current: SeriesTabName = tab.isSeries ? 'series' : 'single'
  return (
    <div className={styles.row}>
      <div className={styles.track} role='tablist' aria-label='Appointment type'>
        {TABS.map(({ name, label }) => (
          <button
            key={name}
            type='button'
            role='tab'
            aria-selected={current === name}
            className={classNames(styles.tab, { [styles.tabOn]: current === name })}
            disabled={tab.switchDisabled || isBusy}
            onClick={() => tab.setTab(name)}>
            {label}
          </button>
        ))}
      </div>
      <span className={styles.note}>{tab.note}</span>
    </div>
  )
}
